import { useState, useEffect } from "react";

import Snackbar from "@mui/material/Snackbar";

import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";

import { useAuth0 } from "@auth0/auth0-react";

import Cookies from "js-cookie";
import useSocketUserDisconnect from "hooks/useSocketUserDisconnect";

function CookieConsent() {
  const { user, logout } = useAuth0();
  const { userDisconnect } = useSocketUserDisconnect();
  const [cookieAccepted, setCookieAccepted] = useState(false);

  const handleDecline = () => {
    userDisconnect();
    logout();
  };

  const handleAccept = () => {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 30);

    try {
      Cookies.set(user.email, true, { expires: expirationDate });
      setCookieAccepted(true);
    } catch (error) {
      console.log(`Error setting cookie: ${JSON.stringify(error)}`);
    }
  };

  useEffect(() => {
    try {
      const consentCookie = Cookies.get(user.email);
      if (consentCookie === "true") {
        setCookieAccepted(true);
      }
    } catch (error) {
      console.error(`Error getting cookie: ${JSON.stringify(error)}`);
    }
  }, []);
  return (
    <>
      <Snackbar
        className="cookie-consent-snackbar"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={!cookieAccepted}
        message={`We use cookies to deliver the best browsing experience, personalize content, serve targeted advertisements and analyze site traffic. If you click “ACCEPT“, you consent to our use of first party and third party cookies and direct us to share the data with such third parties. If you click “DECLINE“, you do not allow us to set cookies on your browser, and as a result, you will be logged out.`}
        action={
          <SoftBox display="flex" gap={2}>
            <SoftButton
              sx={{
                backgroundColor: "transparent !important",
                padding: "0.75rem 1.5rem",
              }}
              variant="text"
              onClick={handleDecline}
            >
              Decline
            </SoftButton>
            <SoftButton color="info" variant="contained" onClick={handleAccept}>
              Accept
            </SoftButton>
          </SoftBox>
        }
      />
      {/* {!cookieAccepted && <Backdrop open={!cookieAccepted} style={{ zIndex: 9999 }}></Backdrop>} */}
    </>
  );
}
export default CookieConsent;
